export default function validation(response, messages) {
  if (!response?.data?.error?.validationErrors) return;
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('FUSION_TIERS_TIERS_MUST_BE_FROM_THE_SAME_COMPANY') !== -1) {
        messages.push({
          message: 'detailClient.popupFusionTiers.errors.tiersMustBeFromTheSameCompany',
        });
      }
      if (message.indexOf('FUSION_TIERS_TIERS_MUST_BE_OF_THE_SAME_TYPE') !== -1) {
        messages.push({
          message: 'detailClient.popupFusionTiers.errors.tiersMustBeOfSameType',
        });
      }
      if (message.indexOf('FUSION_TIERS_TIERS_MUST_HAVE_AT_LEAST_ONE_SOUSTYPE_IN_COMMON') !== -1) {
        messages.push({
          message: 'detailClient.popupFusionTiers.errors.tiersMustHaveAtLeastOneSousTypeInCommon',
        });
      }
      if (message.indexOf('FUSION_TIERS_TIERS_MUST_HAVE_THE_SAME_TYPOLOGY') !== -1) {
        messages.push({
          message: 'detailClient.popupFusionTiers.errors.tiersMustHaveTheSameTypology',
        });
      }
      if (message.indexOf('FUSION_TIERS_TIERS_TO_BE_RETAINED_IS_LINKED_TO_A_USER') !== -1) {
        messages.push({
          message: 'detailClient.popupFusionTiers.errors.tiersToBeRetainedIsLinkedToAUser',
        });
      }
      if (message.indexOf('FUSION_TIERS_TIERS_TO_BE_RETAINED_IS_LINKED_TO_AT_LEAST_ONE_COMPANY') !== -1) {
        messages.push({
          message: 'detailClient.popupFusionTiers.errors.tiersToBeRetainedIsLinkedToAtLeastOneCompany',
        });
      }
      if (message.indexOf('FUSION_TIERS_TIERS_TO_BE_MERGED_IS_LINKED_TO_A_USER') !== -1) {
        messages.push({
          message: 'detailClient.popupFusionTiers.errors.tiersToBeMergedIsLinkedToAUser',
        });
      }
      if (message.indexOf('FUSION_TIERS_TIERS_TO_BE_MERGED_IS_LINKED_TO_AT_LEAST_ONE_COMPANY') !== -1) {
        messages.push({
          message: 'detailClient.popupFusionTiers.errors.tiersToBeMergedIsLinkedToAtLeastOneCompany',
        });
      }
    }
  });
}
